import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 2}px;

  @media (min-width: 1025px) {
    justify-content: center;
    flex-direction: row;
  }
`;
